import React from 'react'
import { CreditCard } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminPayments = () => {
  return (
    <GenericTable
      tableName="payments"
      title="Payments"
      icon={CreditCard}
      iconColor="emerald"
      searchFields={['payment_number', 'payment_status', 'payment_method', 'payment_type', 'beneficiary_name']}
      hiddenFields={['payment_id', 'created_at', 'updated_at']}
      primaryKey="payment_id"
      defaultFields={['payment_number', 'payment_amount', 'payment_status', 'payment_type', 'payment_method', 'payment_date', 'beneficiary_name', 'beneficiary_bank', 'currency']}
      addFields={['claim_id', 'customer_id', 'payment_amount', 'payment_status', 'payment_type', 'payment_method', 'beneficiary_name', 'beneficiary_bank', 'beneficiary_account', 'beneficiary_ifsc']}
      editFields={[
        'payment_amount', 'payment_status', 'payment_type', 'payment_method', 'payment_date',
        'beneficiary_name', 'beneficiary_bank', 'beneficiary_account', 'beneficiary_ifsc',
        'payer_name', 'payer_account', 'tax_deducted_amount', 'tds_applicable', 'charges_deducted',
        'currency', 'payment_notes', 'payment_reference'
        // Excluded: payment_id, payment_number, claim_id, customer_id, created_at, updated_at
      ]}
    />
  )
}

export default AdminPayments
